import styled from 'styled-components';

export const NavbarWrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  background: ${({ theme }) => theme.landing.navbarBg};
  backdrop-filter: blur(24px);
  border-bottom: 1px solid ${({ theme }) => theme.landing.navbarBorder};
  transition: all 0.3s ease;
  z-index: 1000;
`;

export const NavbarContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.landingSpacing.xl};
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    padding: 0 ${({ theme }) => theme.landingSpacing.lg};
    height: 56px;
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: 0 ${({ theme }) => theme.landingSpacing.md};
    height: 56px;
  }
`;

export const BrandSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.md};
`;

export const UserMenu = styled.div`
  position: relative;
`;

export const UserMenuTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const UserMenuDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 240px;
  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  padding: ${({ theme }) => theme.landingSpacing.md};
  z-index: 1000;
  animation: slideDown 0.2s ease;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    width: 200px;
    right: -8px;
  }
`;

export const UserMenuHeader = styled.div`
  padding: ${({ theme }) => theme.landingSpacing.sm} 0;
  margin-bottom: ${({ theme }) => theme.landingSpacing.sm};
`;

export const UserName = styled.p`
  font-weight: 600;
  font-size: 0.95rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.text};
  margin: 0;
  padding: 0;
  text-transform: capitalize;
`;

export const UserRole = styled.p`
  font-weight: 400;
  font-size: 0.85rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.textSecondary};
  margin: 2px 0 0 0;
  padding: 0;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.landing.cardBorder};
  margin: ${({ theme }) => theme.landingSpacing.sm} 0;
`;

export const MenuItemButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  background: transparent;
  border: none;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
  font-weight: 500;
  font-size: 0.95rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.text};
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.landing.textSecondary};
    transition: color 0.2s ease;
  }

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};

    svg {
      color: ${({ theme }) => theme.landing.text};
    }
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const LogoutButton = styled(MenuItemButton)`
  color: ${({ theme }) => theme.landing.errorColor};
  margin-top: ${({ theme }) => theme.landingSpacing.xs};

  svg {
    color: ${({ theme }) => theme.landing.errorColor};
  }

  &:hover {
    background: rgba(239, 68, 68, 0.1);

    svg {
      color: ${({ theme }) => theme.landing.errorColor};
    }
  }
`;
